(function () {
  const PROXY_BASE = '/apps/sfexpress';
  const customerId = window.SF_CONFIG?.customerId;
  const IS_EN      = window.SF_CONFIG?.locale === 'en';

  const REGIONS = {
    HKI: { zh: '香港島', en: 'Hong Kong Island' },
    KLN: { zh: '九龍',   en: 'Kowloon' },
    NT:  { zh: '新界',   en: 'New Territories' },
  };

  let allStations     = [];
  let currentType     = 'station';
  let currentRegion   = null;
  let selectedStation = null;
  let initialized     = false;

  // ── 初始化（只需一次，用事件委派）──────────────────────
  function init() {
    if (initialized) return;
    initialized = true;
    bindEvents();
    console.log('[SF] initialized');
  }

  // ── 事件委派（綁定到 document，不受 DOM 替換影響）──────
  function bindEvents() {
    // 大區按鈕
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('.sf-region-btn');
      if (!btn) return;
      const regionKey = btn.dataset.region;
      if (!REGIONS[regionKey]) return;

      currentRegion = REGIONS[regionKey];
      document.querySelectorAll('.sf-region-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      resetFrom('district');
      await loadDistricts(currentRegion);
      const districtRow = document.getElementById('sf-district-row');
      if (districtRow) districtRow.style.display = 'block';
    });

    // 分區變更
    document.addEventListener('change', async function (e) {
      if (e.target.id !== 'sf-district') return;
      if (!e.target.value) return;
      resetFrom('type');
      const typeRow = document.getElementById('sf-type-row');
      if (typeRow) typeRow.style.display = 'block';
    });

    // 類型按鈕
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('.sf-type-btn');
      if (!btn) return;
      document.querySelectorAll('.sf-type-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      currentType = btn.dataset.type || 'station';
      const districtEl = document.getElementById('sf-district');
      if (!districtEl?.value) return;
      await loadStations(JSON.parse(districtEl.value));
    });

    // 文字篩選
    document.addEventListener('input', function (e) {
      if (e.target.id !== 'sf-filter-input') return;
      renderStations(e.target.value.trim().toLowerCase());
    });

    // 更改按鈕
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#sf-change-btn')) return;
      const selectedDisplay = document.getElementById('sf-selected-display');
      const pickerBody      = document.getElementById('sf-picker-body');
      if (selectedDisplay) selectedDisplay.style.display = 'none';
      if (pickerBody)      pickerBody.style.display      = 'block';
      selectedStation = null;
    });

    // 儲存地址按鈕
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('#sf-save-address-btn');
      if (!btn || !selectedStation || !customerId) return;

      btn.disabled = true;
      btn.textContent = IS_EN ? 'Saving...' : '儲存中...';

      const name    = IS_EN ? (selectedStation.name_en    || selectedStation.name_zh)    : selectedStation.name_zh;
      const address = IS_EN ? (selectedStation.address_en || selectedStation.address_zh) : selectedStation.address_zh;

      try {
        const res = await fetch(`${PROXY_BASE}/update-address`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customerId:  customerId,
            stationName: name,
            address:     address,
            stationCode: selectedStation.code        || '',
            regionZh:    selectedStation.region_zh   || '',
            districtZh:  selectedStation.district_zh || '',
          })
        });
        const data = await res.json();
        if (data.success) {
          btn.textContent = IS_EN ? 'Address Saved' : '已新增至地址簿';
          //btn.style.color = 'green';
        } else {
          throw new Error(data.error || 'Failed');
        }
      } catch (err) {
        btn.disabled = false;
        btn.textContent = IS_EN ? '❌ Retry Later' : '❌ 稍後重試';
        btn.style.color = 'red';
      }
    });

    document.addEventListener('click', function (e) {
  if (!e.target.closest('#sf-login-btn')) return;
  window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
});
  }

  // ── 重置 ────────────────────────────────────────────────
  function resetFrom(step) {
    const steps = ['district', 'type', 'filter', 'list'];
    const idx   = steps.indexOf(step);

    if (idx <= 0) {
      const el = document.getElementById('sf-district');
      if (el) el.innerHTML = `<option value="">${IS_EN ? '-- Select District --' : '-- 選擇分區 --'}</option>`;
      const row = document.getElementById('sf-district-row');
      if (row) row.style.display = 'none';
    }
    if (idx <= 1) {
      const row = document.getElementById('sf-type-row');
      if (row) row.style.display = 'none';
      document.querySelectorAll('.sf-type-btn').forEach(b => b.classList.remove('active'));
      const defaultBtn = document.querySelector('.sf-type-btn[data-type="station"]');
      if (defaultBtn) defaultBtn.classList.add('active');
      currentType = 'station';
    }
    if (idx <= 2) {
      const row = document.getElementById('sf-filter-row');
      if (row) row.style.display = 'none';
      const el = document.getElementById('sf-filter-input');
      if (el) el.value = '';
    }
    if (idx <= 3) {
      const list = document.getElementById('sf-stations-list');
      if (list) { list.style.display = 'none'; list.innerHTML = ''; }
      const loading = document.getElementById('sf-loading');
      if (loading) loading.style.display = 'none';
      const error = document.getElementById('sf-error');
      if (error) error.style.display = 'none';
      allStations = [];
    }
  }

  // ── 從 KV 動態載入分區列表 ──────────────────────────────
  async function loadDistricts(region) {
    const districtEl = document.getElementById('sf-district');
    const loadingEl  = document.getElementById('sf-loading');
    const errorEl    = document.getElementById('sf-error');
    if (!districtEl) return;

    districtEl.innerHTML = `<option value="">${IS_EN ? 'Loading...' : '載入中...'}</option>`;
    if (loadingEl) loadingEl.style.display = 'block';
    if (errorEl)   errorEl.style.display   = 'none';

    try {
      const regionName = IS_EN ? region.en : region.zh;
      const res  = await fetch(`${PROXY_BASE}/stations?region=${encodeURIComponent(regionName)}&type=station`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const seen = new Set();
      const districts = [];
      for (const s of (data.stations || [])) {
        const key = `${s.district_zh}|${s.district_en}`;
        if (!seen.has(key)) {
          seen.add(key);
          districts.push({ zh: s.district_zh, en: s.district_en });
        }
      }

      if (loadingEl) loadingEl.style.display = 'none';

      districtEl.innerHTML = `<option value="">${IS_EN ? '-- Select District --' : '-- 選擇分區 --'}</option>`;
      districts.forEach(d => {
        const opt = document.createElement('option');
        opt.value = JSON.stringify({
          region_zh: region.zh, region_en: region.en,
          district_zh: d.zh,   district_en: d.en,
        });
        opt.textContent = IS_EN ? d.en : d.zh;
        districtEl.appendChild(opt);
      });

    } catch (err) {
      if (loadingEl) loadingEl.style.display = 'none';
      if (errorEl) {
        errorEl.style.display = 'block';
        errorEl.textContent = IS_EN ? `Failed: ${err.message}` : `載入失敗：${err.message}`;
      }
    }
  }

  // ── 載入站點 ────────────────────────────────────────────
  async function loadStations(selected) {
    const loadingEl   = document.getElementById('sf-loading');
    const errorEl     = document.getElementById('sf-error');
    const stationList = document.getElementById('sf-stations-list');
    const filterRow   = document.getElementById('sf-filter-row');
    const filterEl    = document.getElementById('sf-filter-input');

    if (loadingEl)   loadingEl.style.display   = 'block';
    if (errorEl)     errorEl.style.display     = 'none';
    if (stationList) stationList.style.display = 'none';
    if (filterRow)   filterRow.style.display   = 'none';
    if (filterEl)    filterEl.value            = '';
    allStations = [];

    try {
      const region   = IS_EN ? selected.region_en   : selected.region_zh;
      const district = IS_EN ? selected.district_en : selected.district_zh;
      const url = `${PROXY_BASE}/stations?region=${encodeURIComponent(region)}&district=${encodeURIComponent(district)}&type=${currentType}`;

      const res  = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      if (!data.stations?.length) throw new Error(IS_EN ? 'No stations found' : '此分區暫無站點');

      allStations = data.stations;
      if (loadingEl)   loadingEl.style.display   = 'none';
      if (filterRow)   filterRow.style.display   = 'block';
      if (stationList) stationList.style.display = 'block';
      renderStations('');

    } catch (err) {
      if (loadingEl) loadingEl.style.display = 'none';
      if (errorEl) {
        errorEl.style.display = 'block';
        errorEl.textContent = err.message;
      }
    }
  }

  function cleanHours(text) {
  if (!IS_EN) return text;
  return (text || '-')
    .replace(/休息/g, 'Closed')
    .replace(/小時/g, 'Hours')
    .replace(/24小時/g, '24 Hours')
    .replace(/假期/g, 'Holiday')
    .replace(/星期/g, 'Day')
    .replace(/適用/g, 'Applicable')
    .replace(/不適用/g, 'N/A');
}


  // ── 渲染站點 ────────────────────────────────────────────
  function renderStations(keyword) {
  const stationList = document.getElementById('sf-stations-list');
  if (!stationList) return;

  const filtered = keyword
    ? allStations.filter(s => {
        const name    = IS_EN ? s.name_en    : s.name_zh;
        const address = IS_EN ? s.address_en : s.address_zh;
        return (name || '').toLowerCase().includes(keyword) ||
               (address || '').toLowerCase().includes(keyword);
      })
    : allStations;

  if (!filtered.length) {
    stationList.innerHTML = `<div class="sf-pickup__station">${IS_EN ? 'No stations found' : '找不到站點'}</div>`;
    return;
  }

  stationList.innerHTML = filtered.map(s => {
    const name    = IS_EN ? (s.name_en    || s.name_zh)    : s.name_zh;
    const address = IS_EN ? (s.address_en || s.address_zh) : s.address_zh;

    let hoursText = '';
    if (currentType === 'station') {
      hoursText = IS_EN
        ? `Mon-Fri: ${cleanHours(s.hours?.monFri)} · Sat: ${cleanHours(s.hours?.sat)} · Sun: ${cleanHours(s.hours?.sun)}`
        : `週一至五: ${s.hours?.monFri || '-'} / 週六: ${s.hours?.sat || '-'} / 週日: ${s.hours?.sun || '-'}`;
    } else {
      hoursText = IS_EN
        ? `Mon-Sat: ${cleanHours(s.hours?.monSat)} · Sun: ${cleanHours(s.hours?.sun)}`
        : `週一至六: ${s.hours?.monSat || '-'} / 週日: ${s.hours?.sun || '-'}`;
    }

    const idx = allStations.indexOf(s);

    return `
      <div class="sf-pickup__station" 
           onclick="sfSelectStation(${idx})" 
           style="cursor:pointer;">
        <div class="sf-pickup__station-name text-center">
          <i class="sf-bx bx bx-hashtag"></i> 
          ${IS_EN ? s.code : `${s.code} ${name}`}
        </div>
        <hr width="80%">
        <div class="sf-pickup__station-address">
          <i class="sf-bx bx bx-business"></i> ${address}
        </div>
        <br>
        <div class="sf-pickup__station-time">
          <i class="sf-bx bx bx-clock-dashed-half"></i> ${hoursText}
        </div>
      </div>`;
  }).join('');
}

  // ── 選取站點 ────────────────────────────────────────────
  window.sfSelectStation = async function (index) {
    const station = allStations[index];
    if (!station) return;

    selectedStation = station;
    const name    = IS_EN ? (station.name_en    || station.name_zh)    : station.name_zh;
    const address = IS_EN ? (station.address_en || station.address_zh) : station.address_zh;

    const selectedName    = document.getElementById('sf-selected-name');
    const selectedDisplay = document.getElementById('sf-selected-display');
    const pickerBody      = document.getElementById('sf-picker-body');
    const saveBtn         = document.getElementById('sf-save-address-btn');
    const loginPrompt     = document.getElementById('sf-login-prompt');
    const addressBlock    = document.getElementById('sf-address-block');

    if (selectedName)    selectedName.textContent    = IS_EN
    ? `${station.code} - ${address}`
    : `${station.code} ${name} - ${address}`;
    if (selectedDisplay) selectedDisplay.style.display = 'block';
    if (pickerBody)      pickerBody.style.display      = 'none';

    if (saveBtn) {
      saveBtn.disabled    = false;
      saveBtn.style.color = '';
      //saveBtn.textContent = IS_EN ? 'Save to address book' : '新增至地址簿';
    }

    if (customerId) {
      if (loginPrompt)  loginPrompt.style.display  = 'none';
      if (addressBlock) addressBlock.style.display = 'block';
    } else {
      if (loginPrompt)  loginPrompt.style.display  = 'block';
      if (addressBlock) addressBlock.style.display = 'none';
    }

    // 寫入 Cart Attributes
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          SF_PICKUP_ADDRESS: address      || '',
          SF_PICKUP_NAME:    name         || '',
          SF_PICKUP_CODE:    station.code || '',
          SF_PICKUP_TYPE:    currentType,
        }
      })
    });
  };

  // ── 啟動 ────────────────────────────────────────────────
  // 頁面載入時初始化一次（事件委派，永久有效）
  init();

  // cart:update 後更新 customerId（AJAX 購物車可能改變登入狀態）
  document.addEventListener('cart:update', function() {
    // SF_CONFIG 由 theme.liquid 設定，不需要重新初始化事件
    // 但需要重置選擇狀態
    selectedStation = null;
    allStations = [];
    console.log('[SF] cart updated, state reset');
  });

})();
